import _t from 'i18n!nls/onboarding-common';

export const getPopularSkills = () => [
  { id: 'data-analysis', skillName: _t('Data Analysis') },
  { id: 'finance', skillName: _t('Finance') },
  { id: 'computer-programming', skillName: _t('Computer Programming') },
  { id: 'python-programming-language', skillName: _t('Python Programming') },
  { id: 'project-management', skillName: _t('Project Management') },
  {
    id: 'artificial-intelligence-and-machine-learning-ai-ml',
    skillName: _t('Artificial Intelligence and Machine Learning (AI/ML)'),
  },
  { id: 'machine-learning', skillName: _t('Machine Learning') },
  { id: 'artificial-intelligence', skillName: _t('Artificial Intelligence') },
  { id: 'critical-thinking', skillName: _t('Critical Thinking') },
];
